import images from "../../ImageVariables";
import { MobileViewSupplierInfoPropsTypes } from "../MobileViewSupplierInfoPropsTypes";
import "../SCSS/styles.css";
import { parseISO, getDate, getMonth, getYear } from "date-fns";
import { EnumSurveyAnswerStatus } from "../../Common/Enums/EnumsTypes";
export default function MobileViewSupplierInfo({
  monthsHash,
  surveyAnswersInfo,
  handleNextPage,
}: MobileViewSupplierInfoPropsTypes) {
  return (
    <div className="mobile-view-supplier-info-page-main-container">
      <div
        className={`mobile-view-supplier-info-cover
          ${
            surveyAnswersInfo?.surveyStatus !== EnumSurveyAnswerStatus.COMPLETED
              ? "mobile-view-supplier-info-cover"
              : "mobile-view-supplier-info-cover-completed"
          }`}
      >
        <div className="new">
          <div className="mobile-view-supplier-info-wrapper">
            <div className="mobile-view-supplier-info-logo-cover">
              <div className="mobile-view-supplier-view-supplier-company-info">
                <div className="mobile-view-circle">
                  <div className="mobile-view-outer-circle">
                    <div className="mobile-view-inner-circle">
                      <div className="mobile-view-inner-layer">
                        <div className="mobile-view-company-first-alpha">
                          {surveyAnswersInfo?.supplierInfo?.companyDetails?.companyName.substring(
                            0,
                            1
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-view-supplier-info-inner-container-round"></div>
        <div className="mobile-view-supplier-info-inner-container">
          <div className="mobile-supplier-info-supplier-name-industry-cover">
            <div className="mobile-supplier-info-supplier-name-cover">
              <span className="mobile-supplier-name-dynamic-text">
                {surveyAnswersInfo?.supplierInfo?.companyDetails?.companyName}
              </span>
            </div>
            <div className="mobile-supplier-info-supplier-industry-cover">
              <span className="mobile-supplier-industry-type-static-text">
                Industry Type :
              </span>
              <span className="mobile-supplier-industry-type-dynamic-text">
                {surveyAnswersInfo?.supplierInfo?.companyDetails?.industryName}
              </span>
            </div>
            <div className="mobile-supplier-info-supplier-id">
              <span className="mobile-supplier-id">Supplier ID :</span>
              <span className="mobile-supplier-info-supplier-id-type">
                {surveyAnswersInfo?.supplierInfo?.supplierId}
              </span>
            </div>

            <div className="mobile-view-current-status-cover">
              <span className="mobile-view-status-cover">Email ID:</span>
              <span className="mobile-view-email-id">
                {surveyAnswersInfo?.supplierInfo?.contactDetails?.emailId}
              </span>
            </div>
          </div>
          <div className="mobile-view-supplier-info-supplier-end-date-cover">
            <div className="mobile-view-survey-end-date-cover">
              <div className="mobile-view-end-date-cover-wrapper">
                <div className="mobile-view-end-date-text-cover">
                  <div className="mobile-view-end-date-text">
                    Assessment End Date
                  </div>
                </div>
                <div className="mobile-view-end-date-number-cover">
                  <div className="mobile-view-end-date-number-wrapper">
                    <div className="mobile-view-end-date-number">
                      {surveyAnswersInfo.surveyInfo?.endDate ? (
                        getDate(
                          parseISO(
                            surveyAnswersInfo?.surveyInfo?.endDate?.toString()
                          )
                        )
                      ) : (
                        <span
                          style={{
                            transform: "translateY(50%)",
                            fontSize: "0.9rem",
                            width: "155px",
                          }}
                        >
                          Assessment not started
                        </span>
                      )}
                    </div>
                    <div className="mobile-view-end-date-month-year">
                      <span className="end-month">
                        {surveyAnswersInfo?.surveyInfo?.endDate &&
                          monthsHash?.[
                            getMonth(
                              parseISO(
                                surveyAnswersInfo?.surveyInfo?.endDate.toString()
                              )
                            )
                          ]}
                      </span>
                      <span className="end-year">
                        {surveyAnswersInfo?.surveyInfo?.endDate &&
                          getYear(
                            parseISO(
                              surveyAnswersInfo?.surveyInfo?.endDate?.toString()
                            )
                          )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {surveyAnswersInfo?.surveyStatus !== EnumSurveyAnswerStatus.COMPLETED && (
        <div className="supplier-next-btn-cover">
          <div className="contact-next-button">
            <div className="next-button">
              <div className="button" onClick={() => handleNextPage()}>
                <span>Next</span>
                <span className="arrow">
                  <img src={images.whiteArrow} alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
